import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import { docTemplateTypes } from 'helpers/docs';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormInput from 'components/forms/FormInput';
import FormLanguageSelector from 'components/forms/FormLanguageSelector';
import FormAutocomplete from 'components/forms/FormAutocomplete';

class DocTemplateData extends EntityPropsUpdater {
  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
      disabled,
      inModal,
    } = this.props;

    return (
      <div class="clearfix">
        {entityLoaded ? (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.formGroup.basic_information}</p>
                  <div class="form-group-attached">
                    <FormInput
                      name="name"
                      label={messages.name}
                      value={entity.getName()}
                      meta={entity.getNameMetaInformation()}
                      validation={entity.getNameValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormInput
                      name="title"
                      label={messages.title}
                      value={entity.getTitle()}
                      meta={entity.getTitleMetaInformation()}
                      validation={entity.getTitleValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormInput
                      name="numberPrefix"
                      label={messages.number_prefix}
                      value={entity.getNumberPrefix()}
                      meta={entity.getNumberPrefixMetaInformation()}
                      validation={entity.getNumberPrefixValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormAutocomplete
                      name="systemType"
                      label={messages.system_type}
                      value={entity.getSystemType()}
                      meta={entity.getSystemTypeMetaInformation()}
                      validation={entity.getSystemTypeValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                      options={docTemplateTypes(messages)}
                      clearable
                    />
                    <FormLanguageSelector onChange={this.updateEntity} value={entity.getLanguage()} />
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <div class="form-group-attached"></div>
                </div>
              </div>
            </Col>
          </Row>
        ) : null}
      </div>
    );
  }
}
DocTemplateData.defaultProps = {
  inModal: false,
};

export default injectIntl(DocTemplateData);
